import { Component, Input } from '@angular/core';
// Service
import { RulesChangeService } from '../../services/rules-change.service';
// Model
import { RulesEvents } from '../../models/inline-rules.event';
import { RuleWorkFlowNewStip } from '../../models/inline-rules.model';

@Component({
	selector: 'cv-schema-render-add-stip',
	templateUrl: './add-stip.component.html',
	styleUrls: ['./add-stip.component.scss']
})
export class AddStipComponent {

	@Input() availableStips: any;
	@Input() path;

	newStip = new RuleWorkFlowNewStip();

	get processing(): boolean {
		return this.rulesChangeService.rulesWorkFlow.processing;
	}

	constructor(private rulesChangeService: RulesChangeService) {
		//
	}

	/**
	 * Doc must exist
	 * @param event 
	 * @param stip 
	 */
	onStipSelectedChange(event, stip): void {
		if (event.target.checked) {
			this.newStip = Object.assign({}, stip);
		} else {
			this.newStip = new RuleWorkFlowNewStip();
		}
	}

	/**
	 * Doc must exist
	 */
	onCreateStip() {
		this.rulesChangeService.rulesDataChanged.next(
			{
				type: RulesEvents.NEW_STIP,
				newStip: this.newStip,
				path: this.path
			}
		)
	}

}
